import React from 'react';
import { Row, Col, Select } from 'antd';
import styled from 'styled-components';

const { Option, OptGroup } = Select;

const SelectRow = styled(Row)``;

const StyledSelect = styled(Select)`
  & .ant-select-selection {
    border: none;
  }
  &:hover {
    border: 1px solid #d9d9d9;
    border-radius: 3px;
  }
`;
const Container = styled.div`
  marging: 10px;
`;

const OPTIONS = [
  {
    label: 'Maintenance',
    options: [
      { value: '1', text: 'Breakdown' },
      { value: '2', text: 'Consumption, Fuel' },
      { value: '3', text: 'Consumption, Oil' },
      { value: '4', text: 'CDriver’s Report' },
      { value: '5', text: 'Inspection, Routine' },
      { value: '6', text: 'Lubrication' },
      { value: '7', text: 'Pre-Delivery' },
      { value: '8', text: 'Preventive Maintenance' },
      { value: '9', text: 'Rework' },
      { value: '10', text: 'Road Call' },
      { value: '11', text: 'Routine' },
      { value: '12', text: 'Noted During PM or Inspection' },
      { value: '13', text: 'No Start' },
      { value: '14', text: 'Consumption, Coolant' },
      { value: '15', text: 'Accessories' },
      { value: '16', text: 'Worn Out' },
      { value: '17', text: 'Safety Lane/Pre-Check Inspection' },
      { value: '18', text: 'Wheel-Off' },
      { value: '19', text: 'Remote Diagnostics' },
      { value: '20', text: 'Wet Preventive Maintenance' },
      { value: '50', text: 'Winterize' },
      { value: '55', text: 'Trailer Washout' },
      { value: '59', text: 'Diagnostic Alert' },
    ],
  },
  {
    label: 'Management Decision',
    options: [
      { value: '21', text: 'Capital Improvement' },
      { value: '22', text: 'Conversion' },
      { value: '23', text: 'Modification' },
      { value: '24', text: 'Special Study' },
      { value: '25', text: 'Non-Contract' },
      { value: '26', text: 'Contract' },
    ],
  },
  {
    label: 'Outside Influence',
    options: [
      { value: '31', text: 'Accident, Non-Reported' },
      { value: '32', text: 'Accident, Reported' },
      { value: '33', text: 'Manufacturer’s Recall' },
      { value: '34', text: 'Statutory Inspection' },
      { value: '35', text: 'Statutory Modification' },
      { value: '36', text: 'Theft' },
      { value: '37', text: 'Vandalism' },
      { value: '38', text: 'Warranty' },
      { value: '39', text: 'Natural Causes' },
      { value: '41', text: 'Abuse of Equipment' },
      { value: '42', text: 'Decommissioned/Sold' },
      { value: '43', text: 'Roadside Inspection' },
      { value: '44', text: 'Campaign' },
      { value: '45', text: 'Damage' },
      { value: '46', text: 'Appearance' },
      { value: '47', text: 'Abuse Caused by Driver' },
      { value: '48', text: 'Abuse Caused by Customer' },
      { value: '49', text: 'Cargo Claim' },
      { value: '52', text: 'Abuse Caused by Shipper' },
      { value: '53', text: 'Goodwill - Manufacturer' },
      { value: '54', text: 'Goodwill - Dealer' },
      { value: '56', text: 'Operations Charge Back' },
      { value: '57', text: 'Environmental Hazard' },
      { value: '58', text: 'Road Hazzard' },
    ],
  },
  {
    label: 'Towing',
    options: [
      { value: '61', text: 'Load Shift/Load Transfer' },
      { value: '62', text: 'Abandonment' },
      { value: '63', text: 'Decking Project' },
      { value: '64', text: 'Driver Out of Hours' },
      { value: '65', text: 'Lockout' },
      { value: '66', text: 'Power Swap' },
      { value: '67', text: 'Relocating/Power Move' },
      { value: '68', text: 'Schedule Storage/Lot Rental' },
      { value: '69', text: 'Secure & Storage/Impound' },
    ],
  },
];

function Reason({ reason, itemKey, changeItemProperty }) {
  const handleChange = (value) => {
    changeItemProperty(itemKey, 'reason', value);
  };

  return (
    <Container id="container">
      <Row style={{ marginBottom: '5px' }}>
        <Col>Reason for Repair:</Col>
      </Row>
      <SelectRow>
        <Col span={24}>
          <Select
            style={{ width: '100%' }}
            onChange={handleChange}
            value={reason}
            data-testid="reason-for-repair-select"
          >
            {OPTIONS.map((group) => (
              <OptGroup key={group.label} label={group.label}>
                {group.options.map((opt) => (
                  <Option key={opt.value} value={opt.value}>
                    {opt.text}
                  </Option>
                ))}
              </OptGroup>
            ))}
          </Select>
        </Col>
      </SelectRow>
    </Container>
  );
}

export default Reason;
